import { useState, useEffect } from "react";
import {  useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import Socials from "layouts/authentication/components/Socials";
import curved9 from "assets/images/curved-images/curved9.jpg";

// Other Imports
import axios from "axios";
import Swal from "sweetalert2";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  // 🔐 Manual Login Handler
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("http://localhost:5000/api/login", {
        email,
        password,
      });

      // ✅ Success alert
      // Swal.fire({
      //   icon: "success",
      //   title: "Login Successful",
      //   position: "center",
      //   showConfirmButton: false,
      //   timer: 3000,
      //   timerProgressBar: true,
      //   customClass: {
      //     popup: "my-swal-popup",
      //   },
      // });

      // ✅ Store token and user
      localStorage.setItem("token", res.data.token || "manual_dummy");
      if (res.data.user) {
        localStorage.setItem("user", JSON.stringify(res.data.user));
      }

      // ✅ Redirect
      setTimeout(() => {
        navigate("/dashboard");
      }, 3000);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error.response?.data?.message || "Something went wrong!",
        position: "center",
        confirmButtonColor: "#d33",
      });
    }
  };

  // 🔐 Google OAuth Handler (access_token via frontend redirect)
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes("access_token")) {
      const params = new URLSearchParams(hash.substring(1));
      const accessToken = params.get("access_token");
      if (accessToken) {
        fetch("http://localhost:5000/auth/google", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ access_token: accessToken }),
        })
          .then((res) => res.json())
          .then((data) => {
            localStorage.setItem("token", accessToken);
            localStorage.setItem("user", JSON.stringify(data.user));
            navigate("/dashboard");
          })
          .catch((err) => {
            console.error("Google login error:", err);
            Swal.fire({
              icon: "error",
              title: "Google Login Failed",
              text: "Something went wrong while logging in with Google.",
            });
          });

        // Clear the hash from URL
        window.history.replaceState(null, null, " ");
      }
    }
  }, []);

  return (
    <BasicLayout
      title="Welcome!"
      description="Use these awesome forms to login or create new account in your project for free."
      image={curved9}
    >
      <Card>
        <SoftBox p={3} mb={1} textAlign="center">
          <SoftTypography variant="h5" fontWeight="medium">
            Sign in
          </SoftTypography>
        </SoftBox>

        {/* Google Login buttons */}
        <SoftBox mb={2}>
          <Socials />
        </SoftBox>

        

        {/* Manual Login Form */}
       
      </Card>
    </BasicLayout>
  );
}

export default Basic;
